import React, {useState} from 'react';

import {AspectRatioOutlined} from '@mui/icons-material';
import {ToggleButton} from '@mui/material';
import {AvatarPropsDefaults, AvatarPropsSchema} from '@usewaypoint/block-avatar';

import BaseSidebarPanel from './helpers/BaseSidebarPanel';
import RadioGroupInput from './helpers/inputs/RadioGroupInput';
import SliderInput from './helpers/inputs/SliderInput';
import TextInput from './helpers/inputs/TextInput';
import MultiStylePropertyPanel from './helpers/style-inputs/MultiStylePropertyPanel';

export default function AvatarSidebarPanel({data, setData}) {
    const [, setErrors] = useState(null);

    const updateData = (d) => {
        const res = AvatarPropsSchema.safeParse(d);
        if (res.success) {
            setData(res.data);
            setErrors(null);
        } else {
            setErrors(res.error);
        }
    };

    const size = data.props?.size ?? AvatarPropsDefaults.size;
    const imageUrl = data.props?.imageUrl ?? AvatarPropsDefaults.imageUrl;
    const alt = data.props?.alt ?? AvatarPropsDefaults.alt;
    const shape = data.props?.shape ?? AvatarPropsDefaults.shape;

    return (
        <BaseSidebarPanel title="Avatar block">
            <SliderInput
                label="Size"
                iconLabel={<AspectRatioOutlined sx={{color: 'text.secondary'}}/>}
                units="px"
                step={3}
                min={32}
                max={256}
                defaultValue={size}
                onChange={(size) => {
                    updateData({...data, props: {...data.props, size}});
                }}
            />
            <RadioGroupInput
                label="Shape"
                defaultValue={shape}
                onChange={(shape) => {
                    updateData({...data, props: {...data.props, shape}});
                }}
            >
                <ToggleButton value="circle">Circle</ToggleButton>
                <ToggleButton value="square">Square</ToggleButton>
                <ToggleButton value="rounded">Rounded</ToggleButton>
            </RadioGroupInput>
            <TextInput
                label="Image URL"
                defaultValue={imageUrl}
                onChange={(imageUrl) => {
                    updateData({...data, props: {...data.props, imageUrl}});
                }}
            />
            <TextInput
                label="Alt text"
                defaultValue={alt}
                onChange={(alt) => {
                    updateData({...data, props: {...data.props, alt}});
                }}
            />

            <MultiStylePropertyPanel
                names={['textAlign', 'padding']}
                value={data.style}
                onChange={(style) => updateData({...data, style})}
            />
        </BaseSidebarPanel>
    );
}
